<template>
  <app-page-wrapper-grid class="forgot-password">
    <div class="iw-layout-grid__row forgot-password__row">
      <div class="iw-layout-grid__col--span-12">
        <div class="forgot-password__link">
          <back-button :route-to="{ name: ROUTE_NAMES.LOGIN }" />
        </div>
      </div>
    </div>

    <div class="iw-layout-grid__row forgot-password__row">
      <div class="iw-layout-grid__col--span-4 iw-layout-grid__col--offset-4-desktop forgot-password__wrapper">
        <template v-if="!apiCalled || responseWithErrors">
          <form class="forgot-password__form">
            <h1 class="iw-page-title">Reset your password</h1>
            <p class="iw-body-text-large forgot-password__text">
              Please enter your email address. We will send you the link to reset your password
            </p>
            <template v-if="(isFormSubmitted && v$.$invalid) || responseWithErrors">
              <app-notifier v-for="(message, index) in errors" :key="index" :type="'failed'" :data="message" />
            </template>
            <app-input
              ref="email"
              v-model="v$.email.$model"
              placeholder="Email"
              label="Email Address"
              :has-error="v$.email.$error && isFormSubmitted"
              class="forgot-password__input"
              :error-message="
                v$.email.$error && isFormSubmitted && !responseWithErrors ? validatorsCollection.get('email').errorMessage : ''
              "
            />
            <app-button text="Send Email" :aria-label="'Send Email'" class="forgot-password__submit" :handler="submit" />
          </form>
        </template>
        <template v-else>
          <div class="forgot-password__mail-sent">
            <h1 class="iw-page-title">Check your email</h1>
            <p class="iw-body-text-large forgot-password__text">
              If there's an account associated with <b>{{ email }}</b
              >, you’ll receive a password reset email shortly.
            </p>
          </div>
        </template>
      </div>
    </div>
  </app-page-wrapper-grid>
</template>

<script>
import { mapActions } from "vuex";
import useVuelidate from "@vuelidate/core";
import { required, email } from "@vuelidate/validators";
import BackButton from "@/components/buttons/back-button/BackButton";
import AppPageWrapperGrid from "@/components/base/app-page-wrapper-grid/AppPageWrapperGrid.vue";
import { ROUTE_NAMES, REQUIRED_ERR_MSG } from "@/utils";

export default {
  name: "ForgotPassword",
  components: {
    BackButton,
    AppPageWrapperGrid
  },
  setup: () => ({ v$: useVuelidate() }),
  data() {
    return {
      email: "",
      isFormSubmitted: false,
      responseWithErrors: false,
      apiCalled: false,
      errors: [],
      validatorsCollection: new Map(),
      ROUTE_NAMES
    };
  },
  validations: {
    email: {
      required,
      email
    }
  },
  methods: {
    ...mapActions("user", ["resetPassword"]),
    submit() {
      this.isFormSubmitted = false;
      this.responseWithErrors = false;
      this.errors.length = 0;

      this.v$.$touch();
      this.checkInvalidFields();
      this.isFormSubmitted = true;

      if (!this.v$.$invalid) {
        return this.resetPassword(this.email)
          .then((response) => {
            this.apiCalled = true;
          })
          .catch((error) => {
            this.responseWithErrors = true;
          });
      }
    },
    checkInvalidFields() {
      this.validatorsCollection.forEach((item) => {
        if (item.validator.$invalid) {
          this.errors.push(REQUIRED_ERR_MSG);
        }
      });
    }
  },
  mounted() {
    this.validatorsCollection.set("email", {
      validator: this.v$.email,
      errorMessage: "Please enter a valid email address"
    });
    this.$refs.email.$el.focus();
  }
};
</script>

<style scoped lang="scss">
.forgot-password {
  padding-top: 12px;
  &__row {
    padding: 12px $spacer;
  }

  &__form {
    button {
      margin-top: 48px;
      height: 46px;
      border-radius: 23px;
    }
  }

  &__text {
    margin: 24px 0;
    line-height: 1.38;
  }

  &__link {
    align-self: flex-start;
  }
}
</style>
